import * as React from 'react'
import { DEVTOOLS_URL } from '../lib/config'

export type TFiddleDevToolsProps = {
  host: string
  secure: boolean
  sessionId: string
  onReloadRequest?: () => void
  previewUpdateCount?: number
}

const PARAM_PREFIX = new URL(DEVTOOLS_URL).search ? '&' : '?'

export class FiddleDevTools extends React.PureComponent<TFiddleDevToolsProps> {
  iframeRef = React.createRef<HTMLIFrameElement>()

  constructor(props: TFiddleDevToolsProps) {
    super(props)
    this.onReloadMessage = this.onReloadMessage.bind(this)
  }

  onReloadMessage(event: MessageEvent) {
    if (event.data === 'devtoolsReload' && this.props.onReloadRequest) {
      this.props.onReloadRequest()
    }
  }

  componentDidMount() {
    addEventListener('message', this.onReloadMessage)
  }

  componentWillUnmount() {
    removeEventListener('message', this.onReloadMessage)
  }

  componentWillReceiveProps(props: TFiddleDevToolsProps) {
    if (props.previewUpdateCount !== this.props.previewUpdateCount) {
      this.iframeRef.current.contentWindow.postMessage('resetNetworkLog', '*')
    }
  }

  getIframeSrc() {
    const { secure, host, sessionId } = this.props
    // The devtools UI doesn't properly decode URL parameters so we have to use
    // string concatenation instead of parsing/modifying/reconstructing the
    // DEVTOOLS_URL with a URL object
    const paramKey = secure ? 'wss' : 'ws'
    return `${DEVTOOLS_URL}${PARAM_PREFIX}${paramKey}=${host}/inspect/${sessionId}`
  }

  render() {
    return (
      <iframe
        src={this.getIframeSrc()}
        style={{
          flex: '1',
          width: '100%',
          height: '100%',
          border: 'none',
          borderTop: 'solid 1px #ccc',
        }}
        ref={this.iframeRef}
      />
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/FiddleDevTools.tsx